import { Body } from '@panwds/react-ui'
import { HUMAN_READABLE_DEVICE_LICENSE_TYPE } from '../../../../constants/LabelConstants'

const DeviceAssetTypeRenderer = ({ value }) => {
  return <Body size="lg" addClassName='tw-truncate'>{HUMAN_READABLE_DEVICE_LICENSE_TYPE[value]}</Body>
}

DeviceAssetTypeRenderer.propTypes = {}
export default DeviceAssetTypeRenderer
